import React, { useEffect, useMemo, useRef, useState } from "react";
import avatar from "./assets/D8FE668F-3F78-48AF-ADDA-AE48297C8C85_LE_auto_x2.jpg";
import { FaTelegramPlane } from "react-icons/fa";
import Collapsible from "./components/Collapsible";
import { blogs, projectData, skills } from "./project-data";
import { FaCheckCircle, FaSchool, FaBuilding } from "react-icons/fa";
import zando from "./assets/zando.JPG";
import Modal from "react-modal";
import { IoMdClose } from "react-icons/io";
import { Link } from "react-router-dom";

const startDate = new Date("2022-08-01");
const now = new Date();

const expYears = Math.floor((now - startDate) / (1000 * 60 * 60 * 24 * 365));

const App = () => {
    const [openModal, setOpenModal] = useState(false);
    const nav_ref = useRef(null);
    const section_ref = useRef(null);

    useEffect(() => {
        const handleScroll = () => {
            let nav = [];
            let sections = [];
            if (nav_ref && section_ref && nav_ref.current && nav_ref.current) {
                nav = nav_ref.current.querySelectorAll("ul > li > a");
                sections = section_ref.current.querySelectorAll("section");
            }
            if (nav.length && sections.length) {
                sections.forEach((sec) => {
                    let top = window.scrollY;
                    let offset = sec.offsetTop - 150;
                    let height = sec.offsetHeight;
                    let id = sec.getAttribute("id");
                    if (top <= 200) {
                        nav.forEach((link) => link.classList.remove("active"));
                        nav[0].classList.add("active");
                    } else if (top + window.innerHeight === document.body.offsetHeight) {
                        nav.forEach((link) => link.classList.remove("active"));
                        nav[nav.length - 1].classList.add("active");
                    } else if (top >= offset && top < offset + height) {
                        nav.forEach((link) => {
                            link.classList.remove("active");
                            if (document.querySelector("ul > li > a[href*=" + id + "]"))
                                document.querySelector("ul > li > a[href*=" + id + "]").classList.add("active");
                        });
                    }
                });
            }
        };
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    const modalData = useMemo(() => {
        if (openModal) {
            return projectData.find((p) => p.id === openModal);
        }
        return null;
    }, [openModal]);

    return (
        <main className="bg-[#191919] text-[#ffffffcf] min-h-screen p-4">
            <nav ref={nav_ref} className="fixed top-36 right-10 hidden md:block text-right text-[14px]">
                <ul>
                    <li>
                        <a href="#me" onClick={() => window.scrollTo(0, 0)} className="active">
                            About me
                        </a>
                    </li>
                    <li>
                        <a href="#skill">Skills set</a>
                    </li>
                    <li>
                        <a href="#experience">Experiences</a>
                    </li>
                    <li>
                        <a href="#education">Education</a>
                    </li>
                    <li>
                        <a href="#contact">Contact & Follow</a>
                    </li>
                </ul>
            </nav>
            <div ref={section_ref} className="m-auto max-w-[768px]">
                <h1 className="text-[2rem] font-bold py-16">
                    {/* When I wrote this code, only God and I understood what I did. Now only God knows. */}
                    Code is like humor. When you have to explain it, it’s bad.
                </h1>
                <section id="whoami" className="flex gap-10 md:flex-row flex-col">
                    <div className="flex-1">
                        <h2 className="text-[1.5rem] font-bold">Hi, I am Outdom</h2>
                        <h3 className="font-bold text-[1.2rem]">Software developer</h3>
                        <p className="text-[14px]">{expYears}+ Years</p>
                        <p className="text-[14px]">
                            Experienced in building clean, scalable, and easy-to-use web applications and mobile apps.
                            Known for creating intuitive and responsive user experiences. Enjoys solving complex
                            problems and improving app functionality.
                        </p>
                        <a
                            href="https://t.me/EavOutDom"
                            target="blank"
                            className="bg-[#222b26] w-full py-3 px-5 mt-12 flex items-center gap-2 rounded"
                        >
                            <FaTelegramPlane />
                            <p className="underline underline-offset-4">Contact Me</p>
                        </a>
                    </div>
                    <img
                        alt="avatar"
                        src={avatar}
                        className="md:mx-0 mx-auto h-[200px] w-[200px] object-cover rounded-full"
                        loading="eager"
                    />
                </section>
                <section id="skill" className="pt-20">
                    <h2 className="text-[1.5rem] font-bold pb-8">SKILL SET</h2>
                    {skills.map((sk, index) => (
                        <Collapsible header={sk.title} key={index}>
                            {sk.list.map((l, i) => (
                                <div key={i} className="border-b border-[#2f2f2f] flex items-center py-1">
                                    <div className="flex items-center gap-2 flex-[5]">
                                        <FaCheckCircle className="ml-1" color="#2d9964" />
                                        <p>{l.name}</p>
                                    </div>
                                    <div className="flex-[7] flex items-center gap-2">
                                        <p className="w-4">{l.level}</p>
                                        <div className="h-1 w-40 bg-[#23312a] relative rounded overflow-hidden">
                                            <div
                                                className="absolute top-0 left-0 h-1 bg-[#2d9964] rounded"
                                                style={{ width: (l.level / 10) * 160 }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </Collapsible>
                    ))}
                </section>
                <section id="experience" className="pt-20">
                    <h2 className="text-[1.5rem] font-bold pb-8">EXPERIENCES</h2>
                    <h3 className="font-bold">Companies</h3>
                    <div className="md:w-96 w-full mt-2 rounded overflow-hidden">
                        <img src={zando} alt="zando" className="w-full h-52" />
                        <div className="bg-[#262626] p-2">
                            <div className="flex items-center gap-2">
                                <FaBuilding color="#2d9964" />
                                <p>ZANDO Co., Ltd</p>
                            </div>
                            <p className="text-[14px]">Software Developer</p>
                            <p className="text-[14px]">Aug 2022 - Till Date</p>
                        </div>
                    </div>
                    <Modal
                        ariaHideApp={false}
                        isOpen={openModal !== false}
                        onRequestClose={() => setOpenModal(false)}
                        overlayClassName="fixed inset-0 bg-[#0f0f0fcc] text-white"
                        className="absolute inset-4 md:top-10  md:left-[400px] md:right-[400px] md:bottom-10 bg-[#202020] text-white p-2 rounded"
                    >
                        <div className="flex justify-end">
                            <button onClick={() => setOpenModal(false)}>
                                <IoMdClose size={20} />
                            </button>
                        </div>
                        {modalData && (
                            <div className="md:pt-32 md:pl-32">
                                <img
                                    src={modalData.img}
                                    alt={modalData.name}
                                    className="rounded-full object-cover w-20 h-20"
                                />
                                <h2 className="text-[1.5rem] font-bold py-6">{modalData.name}</h2>
                                <div className="flex text-[14px]">
                                    <p className="flex-[3] md:flex-1">Company</p>
                                    <p className="flex-[5] md:flex-[3]">{modalData.company}</p>
                                </div>
                                <div className="flex text-[14px]">
                                    <p className="flex-[3] md:flex-1">Role</p>
                                    <p className="flex-[5] md:flex-[3]">{modalData.role}</p>
                                </div>
                                <div className="flex text-[14px]">
                                    <p className="flex-[3] md:flex-1">Accomplishment</p>
                                    <ul
                                        className="flex-[5] md:flex-[3]"
                                        style={{ listStyleType: "circle", listStylePosition: "inside" }}
                                    >
                                        {modalData.accomplishment.map((ac, index) => (
                                            <li key={index}>{ac}</li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        )}
                    </Modal>
                    <h3 className="font-bold pt-8">Projects</h3>
                    <Collapsible header="ZANDO">
                        <div className="grid md:grid-cols-2 grid-cols-1 gap-4">
                            {projectData.map((project) => (
                                <button
                                    key={project.id}
                                    onClick={() => setOpenModal(project.id)}
                                    className="w-full bg-[#262626] p-2 rounded"
                                >
                                    <div className="flex items-center gap-2">
                                        <FaBuilding color="#2d9964" />
                                        <p>{project.name}</p>
                                    </div>
                                    <div className="flex items-center gap-2 py-2">
                                        <img
                                            src={project.img}
                                            alt="text-left"
                                            className="w-10 h-10 rounded-full object-cover"
                                        />
                                        <div className="text-left">
                                            <p className="text-[14px] p-0">{project.role}</p>
                                            <p className="text-[14px] p-0">{project.duration}</p>
                                        </div>
                                    </div>
                                </button>
                            ))}
                        </div>
                    </Collapsible>
                    <h3 className="font-bold pt-8">Blogs</h3>
                    <div className="flex gap-2">
                        {blogs.map((b, i) => (
                            <Link key={i} to={"/blog/" + b.link}>
                                <div className="md:w-96 w-full mt-2 rounded overflow-hidden bg-[#262626] p-2">
                                    <p>{b.name}</p>
                                    <p className="text-[14px]">{b.describe}</p>
                                </div>
                            </Link>
                        ))}
                    </div>
                </section>
                <section id="education" className="pt-20">
                    <h2 className="text-[1.5rem] font-bold pb-8">EDUCATION</h2>
                    <div className="flex md:items-center md:justify-between md: md:flex-row flex-col py-1">
                        <div className="flex items-center gap-2">
                            <FaSchool color="#2d9964" />
                            <p>Bachelor degree in Computer Science</p>
                        </div>
                        <div className="flex md:items-center md:gap-2 flex-col md:flex-row">
                            <p className="text-[14px]">Royal University of Phnom Penh</p>
                            <p className="text-[14px]">2019 - 2023</p>
                        </div>
                    </div>
                    <div className="flex md:items-center md:justify-between md:flex-row flex-col py-1">
                        <div className="flex items-center gap-2">
                            <FaSchool color="#2d9964" />
                            <p>Finished High School</p>
                        </div>
                        <div className="flex md:items-center md:gap-2 flex-col md:flex-row">
                            <p className="text-[14px]">Krong Preah Norodom Mohaleap High School</p>
                            <p className="text-[14px]">2014 - 2019</p>
                        </div>
                    </div>
                </section>
                <section id="contact" className="pt-20 pb-20 md:pb-96">
                    <h2 className="text-[1.5rem] font-bold pb-8">CONTACT & FOLLOW</h2>
                    <a href="tel:+85599789551">
                        <p>+855 99 789 551</p>
                    </a>
                    <a href="https://t.me/EavOutDom" target="blank">
                        <p>Telegram</p>
                    </a>
                    <a href="mailto:eavoutdom400@gmail.com?subject=Subject&body=message%20goes%20here">
                        <p>eavoutdom400@gmail.com</p>
                    </a>
                    <a href="https://www.linkedin.com/in/outdom-eav-2b8496210/" target="blank">
                        <p>Linkedin</p>
                    </a>
                    <a href="https://github.com/EavOutDom" target="blank">
                        <p>Github</p>
                    </a>
                </section>
            </div>
        </main>
    );
};

export default App;
